import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { adminService } from '../../services/admin.service';

const AdminNavbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    adminService.logout();
    navigate('/pmpl/admin');
  };

  return (
    <Nav>
      <Title>Panel de Administración</Title>
      <LogoutButton onClick={handleLogout}>Cerrar Sesión</LogoutButton>
    </Nav>
  );
};

const Nav = styled.nav`
  background: #1a1a1a;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #333;
`;

const Title = styled.h1`
  color: #ffd700;
  margin: 0;
  font-size: 1.5rem;
`;

const LogoutButton = styled.button`
  background: transparent;
  color: #fff;
  border: 1px solid #444;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export default AdminNavbar; 